import { useQuery } from "@tanstack/react-query";
import { dashboardService } from "src/services";
import { is } from "src/util/is";

// Fetches pre-aggregated trend buckets for the dashboard charts. The range and
// granularity are both part of the query key so switching Daily/Weekly/Monthly
// (or the time period) refetches, and react-query dedupes identical requests
// across the energy/session/revenue charts.
export const useTransactionTrends = ({ teamId, timeInterval, granularity, enabled = true }) => {
  const queryKey = ["getTransactionTrends", teamId, granularity, timeInterval];

  return useQuery({
    queryKey,
    queryFn: () =>
      dashboardService.getTransactionTrends(teamId, timeInterval, granularity),
    enabled:
      !is.empty(teamId) &&
      enabled &&
      !is.empty(timeInterval) &&
      !is.empty(timeInterval.start) &&
      !is.empty(timeInterval.end) &&
      !is.empty(granularity),
    staleTime: 60 * 1000,
    refetchOnWindowFocus: false,
  });
};
